// Add CSS variables to :root when the app initializes and watch for changes
import useAuthStore from '../stores/auth';
import { watch } from 'vue';

export default defineNuxtPlugin(() => {
   if (!process.client) {
      return;
   }

   const config = useRuntimeConfig().public;
   const authStore = useAuthStore();
   
   // Function to update CSS variables
   const updateCssVariables = () => {
      // Check if user is USPA portal
      const isUspaPortal = authStore?.user?.site_settings?.portal === 'uspa';
      
      // Set portal-specific colors
      let primaryColor: string, secondaryColor: string;
      
      if (isUspaPortal) {
         primaryColor = (config.uspaPrimaryColor as string) || '#13294b';
         secondaryColor = (config.uspaSecondaryColor as string) || '#a12338';
      } else {
         // Set default values if environment variables are not available
         primaryColor = (config.primaryColor as string) || '#d4af37';
         secondaryColor = (config.secondaryColor as string) || '#e06e03';
      }

      // Set CSS variables at the document root level
      document.documentElement.style.setProperty(
         '--lms-color-brand-primary',
         primaryColor,
      );
      document.documentElement.style.setProperty(
         '--lms-color-brand-secondary',
         secondaryColor,
      );

      // API-driven color scheme overrides
      const colorScheme = authStore?.user?.site_settings?.color_scheme;
      if (colorScheme?.button_background_color) {
         document.documentElement.style.setProperty(
            '--lms-color-button-bg',
            colorScheme.button_background_color,
         );
      }
      if (colorScheme?.main_title_color) {
         document.documentElement.style.setProperty(
            '--lms-color-brand-title',
            colorScheme.main_title_color,
         );
      }
      if (colorScheme?.footer_background_color) {
         document.documentElement.style.setProperty(
            '--lms-color-footer-bg',
            colorScheme.footer_background_color,
         );
      }
   };

   // Initial update
   updateCssVariables();

   // Watch for changes in auth store
   watch(() => [
      authStore?.user?.site_settings?.portal,
      authStore?.user?.site_settings?.color_scheme,
   ], () => {
      updateCssVariables();
   }, { immediate: false, deep: true });
});
